import { useEffect, useRef } from 'react';

export function useAutoRefresh(fetchFn, intervalMs = 15000) {
  const fnRef = useRef(fetchFn);
  fnRef.current = fetchFn;

  useEffect(() => {
    // Polling interval for background data refresh
    const interval = setInterval(() => fnRef.current(), intervalMs);

    // Refetch when tab becomes visible again (covers both tab switch and window focus)
    const onVisibility = () => {
      if (document.visibilityState === 'visible') {
        fnRef.current();
      }
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [intervalMs]);
}
